import { BaseClient } from '../BaseClient';
import {
  ContactPreference,
  ContactPreferenceList,
} from '../compiled-protos/contact_preference';
import { ContactPreferenceServiceClient } from '../compiled-protos/contact_preference.client';

class ContactPreferenceClient extends BaseClient {
  self: ContactPreferenceServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ContactPreferenceServiceClient(this.transport);
  }

  public async Create(req: ContactPreference) {
    return await this.self.create(req, this.getMetaData()).response;
  }

  public async Get(req: ContactPreference) {
    return await this.self.get(req, this.getMetaData()).response;
  }

  public async Update(req: ContactPreference) {
    return await this.self.update(req, this.getMetaData()).response;
  }

  public async Delete(req: ContactPreference) {
    return await this.self.delete(req, this.getMetaData()).response;
  }

  public async BatchGet(req: ContactPreference) {
    return await this.self.batchGet(req, this.getMetaData()).response;
  }
}

export { ContactPreference, ContactPreferenceList, ContactPreferenceClient };
